export default {
    login: 'ВОЙТИ',
    refund: 'Возместить',
    history_note: 'Здесь отображаются сведения о ваших ​баллах. Пока не видите свои баллы? Информация обновится в течение 24 часов.',
    lucky_flop_start: 'Join Now',
    lucky_flop_congrat: 'Congratulations',
    lucky_flop_get: 'Claim',
    lucky_flop_open: 'OPEN',
    already_member: 'Уже являетесь ​участником?',
    already_member1: 'Уже являетесь ​участником?',
    points: 'баллы',
    warranty_capital_letters: 'Гарантия',
    action: 'Действие',
    rewards_title: 'Rewards',
    type_title: 'Type',
    discount_type: 'Discount',
    available: 'Доступно',
    faq_title: 'Ответы на часто задаваемые вопросы',
    product_rules: 'Только для {product}',
    view_more: 'Еще',
    points_capital_letters: 'Баллы',
    welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
    welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
    complete_profile: 'Заполнить профиль',
    referral: 'INVITE A FRIEND',
    referral_desc: 'Earn EcoCredits for each friend who successfully signs up.',
    referral_btn: 'Join Now',
    minimum_price: 'Минимальная сумма покупки ({price}).',
    off: 'ВЫКЛ',
    days_rules: 'Действительно {days} дн. с момента обмена',
    join_subTitle: 'Станьте участником программы, чтобы получать баллы и эксклюзивные вознаграждения за каждую покупку.',
    current_tier: 'Текущий уровень',
    site_rules: 'Только для магазинов в США.',
    subscribe_hover: 'Вступите в сообщество и получите 500 баллов.',
    received: 'Получено',
    shop: 'МАГАЗИН',
    earn_point_by_order: 'Зарабатывайте при каждом заказе.',
    shop_capital_letters: 'Магазин',
    redeem_ecocredits_title: 'Обменять вознаграждения EcoCredits',
    rules: 'Правила',
    subscribe_text: 'Подпишитесь на новостную рассылку EcoFlow.',
    pending: 'Ожидание',
    welcome_sub_title: 'Добро пожаловать в программу вознаграждений EcoCredits Rewards.',
    no_history_note: 'Пока не видите свои баллы? Информация обновится в течение 24 часов.',
    no_enough_points: 'Не получилось обменять, баллов пока недостаточно',
    see_t_c: 'Ознакомьтесь с Условиями и положениями',
    email_address: 'Адрес эл. почты',
    redeemed: 'Обменяно',
    manually_added: 'Добавлено вручную',
    have_points: 'У вас <code>{points} балл.</code>',
    add_your_birthday: 'Добавьте свой день рождения',
    earning_points: 'ЗАРАБОТАННЫЕ БАЛЛЫ',
    or_text: 'ИЛИ',
    join_title: 'Присоединиться к программе EcoCredits Rewards',

    copy_desc: 'Код скопирован, теперь вы можете использовать его в магазине.',
    manually_deducted: 'Списано вручную',
    join_now: 'ПРИСОЕДИНИТЬСЯ',
    warranty: 'ГАРАНТИЯ',
    status: 'Статус',
    birthday: 'ДЕНЬ РОЖДЕНИЯ',
    points_balance: 'Количество баллов',
    points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
    shop_to_earn_points: 'Покупайте и зарабатывайте баллы',
    stay_too_long: 'Сессия истекла. Обновите страницу и повторите попытку.',
    subscribe_now: 'Подписаться',
    coming_soon: 'Скоро появится в наличии',
    points_activity: 'ИНФОРМАЦИЯ О БАЛЛАХ',
    login_capital_letters: 'Войти',
    login_capital_letters1: 'Войти',
    rewards_redeemed: 'Полученные награды',
    redeedmed_tab_name: 'Redeemed',
    issued_tab_name: 'Issued',
    expired: 'Срок действия истек',
    minimum_num: 'Минимальное количество предметов ({num} шт.).',
    coupon: 'Код для получения скидки',
    subscribe: 'ПОДПИСАТЬСЯ',
    gift_card: 'Подарочная карта',
    profile: 'ПРОФИЛЬ',
    deducted: 'Вычтено',
    registered: 'Зарегистрировано',
    birthday_placeholder: 'ММ / ДД / ГГ',
    give_away: 'Отдавайте',
    discount: 'Скидка',
    edeemed_rewards_note: 'Здесь появятся полученные вами вознаграждения.',
    completed_text: 'Вы уже получили это вознаграждение.',
    points_activity_a: 'Информация о баллах',
    points_tab_name: 'Points Activity',
    rewards_tab_name: 'Rewards Activity',
    earn_points_title: 'Способы получить баллы',
    days_rules2: 'Действителен с {data}.',
    purchase: 'Покупайте',
    used: 'Используется',
    network_error: 'Ошибка сети',
    confirm_btn: 'Подтвердите',
    sign_up_text: '500 баллов за вступление',
    membership_includes: 'ЧЛЕНСТВО ВКЛЮЧАЕТ',
    summary_text: 'Ваши Экокредиты',
    store: 'Магазин',
    sign_up_desc_h: '500 баллов при вступлении.',
    warranty_desc2: '1000 баллов за регистрацию продукта.',
    warranty_desc1: '1000 баллов за регистрацию продукта.',
    ecoflow_benefits: 'Экокредиты',
    redeeming_points: 'ИСПОЛЬЗОВАНИЕ БАЛЛОВ',
    coupon_used_desc: 'Используйте код при оформлении заказа для получения {amont} подарочной карты.',
    add_my_birthday: 'Добавить день рождения',
    date: 'Дата',
    profile_desc1: 'Получите до 1000 баллов за заполнение профиля.',
    profile_desc2: 'Получите до 1000 баллов за дополнительную информацию.',
    membership: 'УЧАСТНИК',
    redeemed_succ: 'Обмен успешно выполнен!',
    birthday_desc2: 'Заработайте {points} очков, указав дату рождения.',
    birthday_desc1: 'Добавьте день рождения и получите баллы.',
    profile_a: 'Профиль',
    grab_title: 'Grab an EcoCredits Bonus',
    grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
    grab_btn_text: 'Grab My Bonus',
    grab_success_title: 'Congratulations',
    grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
    grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
    'no-grab-content-note': 'More offers coming soon!',
    copy_desc_2: 'You have copied the code.',
    city_validatino_error: 'Invalid city',
    product_text: 'Product',
    shipping_address_text: 'Shipping address',
    saved_address_text: 'Saved addresses',
    use_new_address: 'use a new address',
    spend_now: 'Spend Now',
    stock_left: '{stock} Left',
    no_stock_tip: 'Coming soon... Stay tuned!',
    order_text: 'Order',
    campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
    confirm_btn_text: 'OK',
    points_cash: 'Points Redemption',
    Pending1: 'Pending',
    rollback: 'Returned',
    level_change_log: 'Tier Activity',
    deadline: 'Valid Until',
    history_refresh_member: 'Current Tier: Member',
    history_refresh_plus_member: 'Current Tier: PLUS Member',
    register: 'Register as a Member',
    upgrade: 'Upgrade to PLUS Member',
    demotion: 'Downgrade to Member',
    relegation: 'Maintain as PLUS Member',
    wattayear_2024: 'Share#WattAYear',
    site_account_profile_save_success: 'Success',
    not_eligible: 'You are not eligible to participate in this event.',
};
